<template>
  <section
    v-if="!initialLoading"
    class="categorized-news-module-component">
    <div class="categories inner-container">
      <ul class="categories-list cat-desktop">
        <template
          v-for="(category, idx) of allCategories"
          :key="`category-${idx}`">
          <li
            v-if="category.count && category.count > 0"
            class="category">
            <button @click="selectCategoryDesktop(category)">
              {{ category.name }}
            </button>
            <div
              class="circle-idx sphere"
              :class="{
                active: currentCat.databaseId === category.databaseId,
              }" />
          </li>
        </template>
      </ul>
      <div class="categories-list cat-mobile">
        <div class="controls">
          <button
            v-if="allCategories.length > 1"
            class="prev"
            :class="{ disabled: currentIndexMobile === 0 }"
            :disabled="currentIndexMobile === 0"
            @click="prev()">
            <img src="@/assets/img/arrow-right.svg" />
          </button>
          <span class="controls-current">{{ currentCat.name }} </span>
          <button
            v-if="allCategories.length > 1"
            class="next"
            :class="{
              disabled:
                !allCategories[currentIndexMobile + 1] ||
                allCategories[currentIndexMobile + 1].count === null,
            }"
            :disabled="
              !allCategories[currentIndexMobile + 1] ||
              allCategories[currentIndexMobile + 1].count === null
            "
            @click="next()">
            <img src="@/assets/img/arrow-right.svg" />
          </button>
        </div>
        <div class="indexes">
          <div class="categories-mobile-line" />
          <template
            v-for="(category, catIdx) of allCategories"
            :key="`idx-category-${catIdx}`">
            <div
              v-if="category.count && category.count > 0"
              class="index sphere"
              :class="{ active: currentIndexMobile === catIdx }" />
          </template>
        </div>
      </div>
    </div>
    <div class="categories-dt-line inner-container" />
    <div class="items inner-container">
      <ul
        v-if="postData.length > 0"
        :key="`items-category-${currentCat.name}`"
        class="items-list active">
        <li
          v-for="(item, itemIdx) of postData"
          :key="`item-${itemIdx}-cat-category-${item.databaseId}`"
          class="item">
          <div
            class="item-top"
            v-html="item.title" />
          <div class="item-bot">
            <div class="item-bot-left">
              <span class="item-bot-left-date">
                {{ formatDate(item.date) }}
              </span>
              <span
                v-if="item.postAcf.source"
                class="item-bot-left-source">
                {{ item.postAcf.source }}
              </span>
            </div>
            <div class="item-bot-right">
              <ButtonGlobal
                :text="item.categories.nodes[0].categoryColor.btn_text"
                :url="item.postAcf.link"
                target="_blank" />
            </div>
            <div
              class="category-color"
              :class="
                item.categories.nodes[0].categoryColor.categoryColor[0]
              " />
          </div>
        </li>
      </ul>
      <div v-else-if="!dataLoading && postData.length === 0">
        <div class="item">
          <p>No posts found for this category.</p>
        </div>
      </div>
      <div
        v-else-if="dataLoading"
        class="w-full flex flex-col gap-y-6">
        <div class="loading-container w-full flex flex-col lg:flex-row gap-6">
          <div class="item w-full lg:w-1/2 bg-white p-6">
            <div
              role="status"
              class="animate-pulse">
              <div
                class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-300 w-full mb-4"></div>
              <div
                class="h-2 bg-gray-200 rounded-full dark:bg-gray-300 w-[90%] mb-2.5"></div>
              <div class="p-10"></div>
              <div class="flex w-full h-fit gap-x-14">
                <div class="w-9/12">
                  <div
                    class="h-2 bg-gray-200 rounded-full dark:bg-gray-300 w-[60%] mb-2.5"></div>
                  <div
                    class="h-2 bg-gray-200 rounded-full dark:bg-gray-300 w-[40%] mb-2.5"></div>
                </div>
                <div class="w-3/12">
                  <div
                    class="h-10 bg-gray-200 dark:bg-gray-300 w-full mb-2.5"></div>
                </div>
              </div>

              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <div class="item w-full lg:w-1/2 bg-white p-6">
            <div
              role="status"
              class="animate-pulse">
              <div
                class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-300 w-full mb-4"></div>
              <div
                class="h-2 bg-gray-200 rounded-full dark:bg-gray-300 w-[90%] mb-2.5"></div>
              <div class="p-10"></div>
              <div class="flex w-full h-fit gap-x-14">
                <div class="w-9/12">
                  <div
                    class="h-2 bg-gray-200 rounded-full dark:bg-gray-300 w-[60%] mb-2.5"></div>
                  <div
                    class="h-2 bg-gray-200 rounded-full dark:bg-gray-300 w-[40%] mb-2.5"></div>
                </div>
                <div class="w-3/12">
                  <div
                    class="h-10 bg-gray-200 dark:bg-gray-300 w-full mb-2.5"></div>
                </div>
              </div>

              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </div>
        <div class="loading-container w-full flex flex-col lg:flex-row gap-6">
          <div class="item w-full lg:w-1/2 bg-white p-6">
            <div
              role="status"
              class="animate-pulse">
              <div
                class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-300 w-full mb-4"></div>
              <div
                class="h-2 bg-gray-200 rounded-full dark:bg-gray-300 w-[90%] mb-2.5"></div>
              <div class="p-10"></div>
              <div class="flex w-full h-fit gap-x-14">
                <div class="w-9/12">
                  <div
                    class="h-2 bg-gray-200 rounded-full dark:bg-gray-300 w-[60%] mb-2.5"></div>
                  <div
                    class="h-2 bg-gray-200 rounded-full dark:bg-gray-300 w-[40%] mb-2.5"></div>
                </div>
                <div class="w-3/12">
                  <div
                    class="h-10 bg-gray-200 dark:bg-gray-300 w-full mb-2.5"></div>
                </div>
              </div>

              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <div class="item w-full lg:w-1/2 bg-white p-6">
            <div
              role="status"
              class="animate-pulse">
              <div
                class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-300 w-full mb-4"></div>
              <div
                class="h-2 bg-gray-200 rounded-full dark:bg-gray-300 w-[90%] mb-2.5"></div>
              <div class="p-10"></div>
              <div class="flex w-full h-fit gap-x-14">
                <div class="w-9/12">
                  <div
                    class="h-2 bg-gray-200 rounded-full dark:bg-gray-300 w-[60%] mb-2.5"></div>
                  <div
                    class="h-2 bg-gray-200 rounded-full dark:bg-gray-300 w-[40%] mb-2.5"></div>
                </div>
                <div class="w-3/12">
                  <div
                    class="h-10 bg-gray-200 dark:bg-gray-300 w-full mb-2.5"></div>
                </div>
              </div>

              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </div>
        <div class="loading-container w-full flex flex-col lg:flex-row gap-6">
          <div class="item w-full lg:w-1/2 bg-white p-6">
            <div
              role="status"
              class="animate-pulse">
              <div
                class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-300 w-full mb-4"></div>
              <div
                class="h-2 bg-gray-200 rounded-full dark:bg-gray-300 w-[90%] mb-2.5"></div>
              <div class="p-10"></div>
              <div class="flex w-full h-fit gap-x-14">
                <div class="w-9/12">
                  <div
                    class="h-2 bg-gray-200 rounded-full dark:bg-gray-300 w-[60%] mb-2.5"></div>
                  <div
                    class="h-2 bg-gray-200 rounded-full dark:bg-gray-300 w-[40%] mb-2.5"></div>
                </div>
                <div class="w-3/12">
                  <div
                    class="h-10 bg-gray-200 dark:bg-gray-300 w-full mb-2.5"></div>
                </div>
              </div>

              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <div class="item w-full lg:w-1/2 bg-white p-6">
            <div
              role="status"
              class="animate-pulse">
              <div
                class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-300 w-full mb-4"></div>
              <div
                class="h-2 bg-gray-200 rounded-full dark:bg-gray-300 w-[90%] mb-2.5"></div>
              <div class="p-10"></div>
              <div class="flex w-full h-fit gap-x-14">
                <div class="w-9/12">
                  <div
                    class="h-2 bg-gray-200 rounded-full dark:bg-gray-300 w-[60%] mb-2.5"></div>
                  <div
                    class="h-2 bg-gray-200 rounded-full dark:bg-gray-300 w-[40%] mb-2.5"></div>
                </div>
                <div class="w-3/12">
                  <div
                    class="h-10 bg-gray-200 dark:bg-gray-300 w-full mb-2.5"></div>
                </div>
              </div>

              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="item">
          <p>There was an error loading the posts.</p>
        </div>
      </div>
      <div class="load-more">
        <ButtonGlobal
          v-if="showMore"
          :disable="loadingShowMore"
          class="load-more-btn"
          :text="loadingShowMore ? 'loading more news...' : 'Load More'"
          theme="white-purple"
          @click="loadMore()" />
        <div v-if="!showMore"><p>You have reached the end of the list.</p></div>
      </div>
    </div>
  </section>
  <section
    v-else
    class="loading-transition inner-container">
    <div
      role="status"
      class="animate-pulse flex justify-between w-full py-10 px-6 border-l border-l-lm_orange">
      <div
        class="h-10 bg-gray-200 rounded-full dark:bg-gray-300 w-48 mb-4"></div>
      <div
        class="h-10 bg-gray-200 rounded-full dark:bg-gray-300 w-48 mb-4"></div>
      <div
        class="h-10 bg-gray-200 rounded-full dark:bg-gray-300 w-48 mb-4"></div>
      <span class="sr-only">Loading...</span>
    </div>
  </section>
</template>

<script setup>
/* #META
{
  "NAME": "CategorizedNewsComponent",
  "CLASSNAME": "categorized-news-module-component",
  "URL": "http://lifemine.local/templates/"
}
#ENDMETA */
import ButtonGlobal from '@/components/utility/ButtonGlobal.vue'
import useGQL from '@/composables/useGQL.js'

import { ref, onBeforeMount, watch } from 'vue'

const { gqlQuery } = useGQL()
const postData = ref([])
const allCategories = ref([])
const currentCat = ref(0)
const lastCursor = ref(null)
const showMore = ref(0)
const loadingShowMore = ref(false)
const currentIndexMobile = ref(0)
const initialLoading = ref(true)
const dataLoading = ref(false)

const selectCategoryDesktop = (newCat) => {
  currentCat.value = newCat
}

const prev = () => {
  if (currentIndexMobile.value !== 0) {
    currentCat.value = allCategories.value[currentIndexMobile.value - 1]
    currentIndexMobile.value--
  }
}

const next = () => {
  if (
    currentIndexMobile.value !== allCategories.value.length - 1 &&
    allCategories.value[currentIndexMobile.value + 1].count > 0
  ) {
    currentCat.value = allCategories.value[currentIndexMobile.value + 1]
    currentIndexMobile.value++
  }
}

const formatDate = (date) => {
  let newDate = new Date(date)
  let options = { year: 'numeric', month: 'long', day: 'numeric' }
  return newDate.toLocaleDateString('en-US', options)
}

const loadMore = async () => {
  loadingShowMore.value = true
  const news = await getNews(currentCat.value, lastCursor.value)
  postData.value = [...postData.value, ...news]
  loadingShowMore.value = false
}

const getNews = async (catId, after = null) => {
  dataLoading.value = true
  const postData = await gqlQuery(`
  query getPosts {
    posts(first: 8, where: {
      categoryId: ${catId.databaseId}
    }, after: "${after}") {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        databaseId
        date
        title
        postAcf {
          link
          source
        }
        categories {
          nodes {
          categoryColor {
            categoryColor
            btn_text
          }
        }
      }
      }
    }
  }
  `)

  lastCursor.value = postData.data.posts.pageInfo.endCursor
  showMore.value = postData.data.posts.pageInfo.hasNextPage
  dataLoading.value = false
  return postData.data.posts.nodes
}

const getNewsCategories = async () => {
  const categories = await gqlQuery(`
    query getPostsCategories {
    categories {
      nodes {
        databaseId
        name
        count
      }
    }
  }
  `)
  const sortedCategories = [...categories.data.categories.nodes]
  sortedCategories.sort((a) => {
    if (a.name.includes('Press')) {
      return -1
    }
    if (a.name.includes('Publications')) {
      return 1
    }
  })
  return sortedCategories
}

watch(currentCat, async () => {
  const news = await getNews(currentCat.value)
  postData.value = news
})

onBeforeMount(async () => {
  const newsCategories = await getNewsCategories()
  allCategories.value = newsCategories
  currentCat.value = newsCategories[0]
  initialLoading.value = false
})
</script>

<style lang="scss">
.categorized-news-module-component {
  --first-gradient: linear-gradient(90deg, #99b4ff 0%, #6fcfd7 100%);
  --second-gradient: linear-gradient(90deg, #6fcfd7 0%, #ffad39 100%);
  --third-gradient: linear-gradient(90deg, #ffad39 0%, #ff6d00 100%);

  @apply bg-lm_white;

  .sphere {
    @apply w-[12px] h-[12px] lg:w-[17px] lg:h-[17px] rounded-full bg-lm_orange blur-[2px];
    background-color: #ff6d00;
    box-shadow: 0 0 20px #ff6d00;
    &.active {
      @apply scale-[1.7] lg:scale-100;
    }
  }

  .categories {
    .categories-list {
      @apply border-l-lm_orange border-l-[1px] border-solid;

      &.cat-desktop {
        @apply hidden lg:flex lg:justify-center lg:gap-[155px];

        .category {
          @apply relative mb-6 mt-16 lg:text-[22px];

          .circle-idx {
            @apply opacity-0 absolute -bottom-[32.5px] transition-all;
            left: 50%;
            transform: translateX(-50%);

            &.active {
              @apply opacity-100;
            }
          }
        }
      }

      &.cat-mobile {
        @apply flex flex-col lg:hidden;

        .controls {
          @apply mb-6 mt-10 flex justify-between px-[50px];

          .prev {
            img {
              @apply transition-all rotate-180;
            }
          }

          .prev,
          .next {
            &.disabled {
              img {
                @apply opacity-30;
              }
            }
          }

          &-current {
            @apply large text-center w-full;
          }
        }

        .indexes {
          @apply translate-y-[calc(17px_/_2)] relative flex justify-center gap-[90px];

          .categories-mobile-line {
            @apply absolute w-full bg-lm_orange h-[1px];
            top: 50%;
            transform: translateY(-50%);
          }
        }
      }
    }
  }

  .categories-dt-line {
    @apply opacity-0 lg:opacity-100 border-b-lm_orange border-b-[1px] border-solid mb-[56px];
  }

  .items {
    @apply flex flex-col items-center gap-5 lg:gap-20 lg:px-[50px];

    .items-list {
      @apply w-full hidden flex-col gap-5 lg:flex-row lg:flex-wrap;

      &.active {
        @apply flex;
      }

      .item {
        @apply relative bg-white p-8 flex flex-col justify-between gap-11 min-h-max lg:w-[calc(50%_-_10px)] lg:min-h-0 lg:h-[280px] lg:gap-5;

        &-top {
          @apply medium lg:min-h-[130px];
        }

        &-bot {
          @apply flex flex-col gap-[20px] lg:flex-row lg:gap-0 lg:justify-between;

          &-left {
            @apply flex flex-col gap-[10px] lg:min-h-[58px] lg:justify-center;

            &-date {
              @apply small text-[#4D4D4D];
            }

            &-source {
              @apply small text-[#4D4D4D] lg:min-h-6;
            }
          }

          &-right {
          }
        }

        .category-color {
          @apply absolute bottom-0 left-0 w-full h-[10px];

          &.btt {
            background: var(--first-gradient);
          }

          &.tty {
            background: var(--second-gradient);
          }

          &.yto {
            background: var(--third-gradient);
          }
        }
      }
    }

    .load-more {
      @apply mb-9 lg:mb-20;
    }
  }
}
</style>
